export const SET_QUERY: "search/SET_QUERY" = "search/SET_QUERY";
